import React from 'react';
import {useParams} from 'react-router-dom';
import { NavLink } from "react-router-dom";
import RecordDetails from "components/recordDetails/RecordDetails";

export function Details(props){

  const {id} = useParams();

  // const [connections, setConnections] = useState([]);
  // const [realms, setRealms] = useState([]);
  // const list = useAPI('/api/app_connection');
  
  return (
    <>
    <nav className='subnav'>

    <NavLink exact to='/client/logs' activeClassName='active'>All Activity</NavLink>
    <NavLink exact to='/client/logs/cleanup' activeClassName='active'>Cleanup</NavLink>
    <NavLink  to='/client/logs/details' activeClassName='active'>Details</NavLink>
    </nav>

        {/* <Breadcrumbs items={[
          { name: 'Logs', url: '/client/logs' },
          { name: 'Record Details', url: '#' }
        ]}/> */}
        <RecordDetails id={id} />
       

    </>
  );
}



